import { gql } from "@apollo/client";
import "../../api/types.js";
import { GqlRequestBuilder } from "../../api/GqlRequestBuilder.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "moment-timezone";
import { nameOf } from "../../utils/object.js";
import "react-intl";
class PlayerReferralRequestBuilder extends GqlRequestBuilder {
  validateFilters(_filter) {
    return;
  }
  buildFilter(filter) {
    return {
      filter: {
        text: this.getGQLTextFilter([
          ...Object.keys(this.filterFieldsMapper).map(
            (key) => this.toGQLTextFilter(this.filterFieldsMapper[key], filter[key])
          )
        ])
      }
    };
  }
  buildQuery(fields) {
    return gql`
            query GetPlayerReferrals($filter: PlayerReferralsFilter, $sort: Sorting, $start: Int, $end: Int) {
                getPlayerReferrals(filter: $filter, sort: $sort, start: $start, end: $end)
                {
                    items {
                        referrer_id ${this.hasQueryItem(fields, "referrer_id")}
                        invite_code ${this.hasQueryItem(fields, "invite_code")}
                        referee ${this.hasAnyOfQueryItems(fields, this.getRefereeQueryItems())} {
                            uid ${this.hasQueryItem(fields, "referee.uid")}
                        }
                        revenue_share ${this.hasQueryItem(fields, "revenue_share")}
                        revenue_generated_total ${this.hasQueryItem(fields, "revenue_generated_total")}
                        revenue_share_offering_status ${this.hasQueryItem(fields, "revenue_share_offering_status")}
                        expiration_date ${this.hasAnyOfQueryItems(fields, this.getExpirationDateQueryItems())} {
                            seconds ${this.hasQueryItem(fields, "expiration_date.seconds")}
                        }
                    }
                    total_count
                }
            }
        `;
  }
  getRefereeQueryItems() {
    return ["referee.uid"];
  }
  getExpirationDateQueryItems() {
    return ["expiration_date.seconds"];
  }
  filterFieldsMapper = {
    referee_uid: [nameOf("referee_uid")],
    referrer_id: [nameOf("referrer_id")]
  };
  getAddReferrerMutation() {
    return gql`
            mutation AddReferrer($referral: PlayerReferralInput!) {
                addReferrer(referral: $referral) {
                    referrer_id
                    referee {
                        uid
                    }
                    revenue_share
                    revenue_generated_total
                    invite_code
                }
            }
        `;
  }
  getUpdateReferrerInfoMutation() {
    return gql`
            mutation UpdateReferrer($referral: PlayerReferralInput!) {
                updateReferrer(referral: $referral) {
                    referrer_id
                    referee {
                        uid
                    }
                    revenue_share
                    revenue_generated_total
                    invite_code
                }
            }
        `;
  }
  getRemoveReferrerInfoMutation() {
    return gql`
            mutation RemoveReferrer($referral: RemovePlayerReferralInput!) {
                removeReferrer(referral: $referral) {
                    referrer_id
                    referee {
                        uid
                    }
                    revenue_share
                    revenue_generated_total
                    invite_code
                }
            }
        `;
  }
  getUpdateRegularPlayerReferralSettingsMutation() {
    return gql`
            mutation UpdateRegularPlayerReferralSettings($referral: ReferralUpdateInput!) {
                updateRegularPlayerReferralSettings(referral: $referral) {
                    referrer_id
                    referee {
                        uid
                    }
                    revenue_share
                    revenue_generated_total
                    invite_code
                    revenue_share_offering_status
                    expiration_date {
                        seconds
                    }
                }
            }
        `;
  }
}
export {
  PlayerReferralRequestBuilder
};
//# sourceMappingURL=requestBuilder.js.map
